<template>
  <div :class="classes()">
    <Modal
      :open="openEdithCarePopup"
      @close="close"
      :headline="$t('edithcare.popup.headline')"
      size="m"
    >
      <Col>
        <Headline size="s">{{ $t('edithcare.popup.advantages.headline') }}</Headline>
        <UnorderedList
          iconColor="primaryBlue"
          :listItems="$t('edithcare.popup.advantages')"
          iconName="check-line"
          class="u-margin__top--2"
        />

        <Headline size="s">{{ $t('edithcare.popup.procedure.headline') }}</Headline>
        <ol :class="`${el}__orderedList`">
          <li
            :class="`${el}__orderedListItem`"
            v-for="(item, index) in $t('edithcare.popup.procedure')"
            :key="index"
          >
            {{ item }}
          </li>
        </ol>

        <Copy
          v-if="error"
          color="supportDanger"
          size="l"
          centered
          staticClass="u-margin__bottom--2"
        >
          {{ $t('edithcare.error.generics') }}
        </Copy>

        <form @submit.prevent="handleSubmit">
          <BaseCheckbox
            name="privacyStatement"
            v-model="formFields.privacyStatement.value"
            :checked="!!formFields.privacyStatement.value"
            :error="formFields.privacyStatement.error"
            @input="clearError(formFields.privacyStatement)"
          >
            <span slot="label">{{ edithcarePrivacyStatement }}</span>
          </BaseCheckbox>
          <Copy staticClass="u-margin__top--2 u-margin__left--5">
            <span
              v-html="
                $t('edithcare.popup.moreInformation', {
                  email: OBJECTION_EMAIL,
                  pflegeLink: 'https://www.pflege.de/kundendatenschutzerklaerung/',
                  edithcareLink: 'https://embedded.edith.care/datenschutzerklaerung',
                })
              "
            />
          </Copy>
          <div :class="`${el}__buttonRow`">
            <Button
              :label="$t('profile.legal.form.button.next')"
              :loading="isLoading"
              submit
              type="outlined"
              small
            />
          </div>
        </form>
      </Col>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal/Modal';
import Headline from '@/objects/Headline/Headline';
import BaseCheckbox from '@/objects/Forms/BaseCheckbox/BaseCheckbox';
import Button from '@/objects/Button/Button';
import Copy from '@/objects/Copy/Copy';

import Vue from 'vue';
import { validateForm } from '@/helpers/formValidation';

import { EDITHCARE_APPLICATION_LINK, OBJECTION_EMAIL } from '@/constants/generics';
import { ROUTE_API_EDITHCARE } from '@/constants/apiRoutes';
import UnorderedList from '@/objects/UnorderedList/UnorderedList';
import Col from '@/components/Grid/Col/Col';
import { mapFieldsApplication, mapFieldsContentSheet } from '@/store/mapFields';
import { CONTENT_SHEET_TOOGLE } from '@/store/actions/contentSheet';
import { TOGGLE_EDITHCARE_POPUP } from '@/store/actions/application';

export default {
  name: 'EdithcarePopUp',
  components: { Col, UnorderedList, Headline, Copy, Button, BaseCheckbox, Modal },
  props: {
    edithcarePrivacyStatement: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapFieldsContentSheet(['contentSheetIsOpen']),
    ...mapFieldsApplication(['openEdithCarePopup']),
  },

  data() {
    return {
      OBJECTION_EMAIL,
      isOpen: false,
      isLoading: false,
      error: false,
      formFields: {
        privacyStatement: {
          value: 0,
          error: null,
          required: this.$t('edithcare.error.privacy.required'),
        },
      },
      el: 'c-edithcarePopUp',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },

  methods: {
    close(src = null) {
      this.$store.dispatch(TOGGLE_EDITHCARE_POPUP);
      this.formFields.privacyStatement.value = 0;
      if (src === 'button') {
        this.$emit('onTrackingClick', '-edithCare-Pop-up_btn-weiter', 'button');
        this.$emit(
          'onTrackingClick',
          `_link-${EDITHCARE_APPLICATION_LINK.replace('?token=', '')}`,
          'link'
        );
      } else {
        this.$emit('onTrackingClick', '-edithCare-Pop-up_click-schließen', 'element');
      }
      this.clearError(this.formFields.privacyStatement);
      this.isLoading = false;
    },

    handleSubmit(e) {
      this.isLoading = true;
      this.error = false;
      const { isValid } = validateForm(e.target.elements, this.formFields);

      if (isValid) {
        Vue.axios
          .post(ROUTE_API_EDITHCARE, {
            privacyStatement: this.formFields.privacyStatement.value,
          })
          .then((response) => {
            if (response.status === 200) {
              const token = response.data.accessToken;
              if (token !== null) {
                window.open(EDITHCARE_APPLICATION_LINK + token);
              }
              if (this.contentSheetIsOpen) {
                this.$store.dispatch(CONTENT_SHEET_TOOGLE);
              }
            }
            this.close('button');
          })
          .catch((err) => {
            if (err.response.status === 422) {
              this.formFields['privacyStatement'].error = this.$t(
                'edithcare.error.privacy.required'
              );
            } else {
              this.error = true;
            }
            this.isLoading = false;
          });
      } else {
        this.isLoading = false;
      }
    },
    clearError(field) {
      field.error = null;
    },
  },
};
</script>
